import { PrinterPosCheckOutlineIcon } from './PrinterPosCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A48714B0-4E0D-480D-9766-C73919F28B73
 * name printer-pos-check-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-check-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptCheckOutlineIcon = PrinterPosCheckOutlineIcon;
export default PrinterReceiptCheckOutlineIcon